import { render, staticRenderFns } from "./view-testing-fee.vue?vue&type=template&id=74b0a5e4&scoped=true&"
import script from "./view-testing-fee.vue?vue&type=script&lang=js&"
export * from "./view-testing-fee.vue?vue&type=script&lang=js&"
import style0 from "./view-testing-fee.vue?vue&type=style&index=0&id=74b0a5e4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0a5e4",
  null
  
)

export default component.exports